import React, {useState} from "react";
import {axiosRun} from "../utils/axiosWrap";
import {config} from "../config";
import {UploadData} from "./UploadData";

export const UpdateUsersEmails = ()=>{
    return <UploadData title={"оновлення емейлів та телефонів у студентів"} linkUpload={config.apiLinks.uploadUserEmails} />
}
